import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export function BuildingsNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`
        fixed top-0 left-0 right-0 z-50
        transition-all duration-300
        ${isScrolled ? 'bg-white shadow-sm' : 'bg-white shadow-sm'}
      `}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-24">
          <div className="flex items-center">
            <Link to="/">
              <img
                src="https://static.readdy.ai/image/55893c4a5915be14917a0a81b6ec721d/f5868736a4ed9c94ff4146ae0bef5b91.png"
                alt="Furnished Rental Management Canada Logo"
                className="h-20 w-auto cursor-pointer"
              />
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-12">
            <Link
              to="/"
              className="text-base font-medium text-[#505A5A] hover:text-[#882629] transition-colors cursor-pointer whitespace-nowrap"
            >
              Home
            </Link>
            <Link
              to="/buildings-that-allow-str"
              className="text-base font-medium text-[#882629] transition-colors cursor-pointer whitespace-nowrap"
            >
              STR Buildings
            </Link>
            <Link
              to="/"
              className="bg-[#882629] text-white px-8 py-3 rounded-full text-base font-semibold hover:bg-[#6E1F22] transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
